import { IntlShape } from 'react-intl';

/**
 * A slot as the artist reads it: the day and the hour, in their own timezone.
 *
 * The wire carries UTC. Nobody schedules a post in UTC, so every screen that
 * shows a slot shows it local.
 */
export function slotLabel(intl: IntlShape, iso: string): string {
  return intl.formatDate(new Date(iso), {
    weekday: 'short',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}
